<template>
  <v-tooltip top>
    <template v-slot:activator="{on, attrs}">
      <h3 v-bind="attrs" v-on="on" class="display-3" v-if="!isNew">
        <v-icon :color="getColor" x-large>
          {{getIcon}}
        </v-icon>
        {{value}}
      </h3>
      <h3 v-bind="attrs" v-on="on" class="display-3" v-else>
        <v-chip label>NEW</v-chip>
      </h3>

    </template>
    <div v-if="!isNew">
      <span>{{currentLabel}}: {{currentValue}}</span>
      <br>
      <span>{{previousLabel}}: {{previousValue}}</span>
    </div>
    <div v-else>
      We have no history yet to compare against
    </div>
  </v-tooltip>
</template>

<script>
  export default {
    name: "increaseDecreaseTooltip",
    props: {
      'currentValue': Number,
      'previousValue': Number,
      percentage: {
        type: Boolean,
        default: true
      },
      currentLabel: {
        type: String,
        default: 'Current'
      },
      previousLabel: {
        type: String,
        default: 'Previous'
      }
    },
    computed: {
      isNew() {
        return this.previousValue === undefined || this.previousValue === 0
      },
      getColor() {
        if (this.previousValue) {
          return this.previousValue === this.currentValue ? 'grey' : (this.currentValue > this.previousValue ? 'error' : 'success');
        }
        return 'grey';
      },
      getIcon() {
        if (this.previousValue) {
          return this.previousValue === this.currentValue ? 'mdi-equal' : (this.currentValue > this.previousValue ? 'mdi-arrow-up' : 'mdi-arrow-down');
        }
        return 'mdi-equal';
      },
      value() {
        const value = Math.round(this.currentValue / this.previousValue * 100 - 100)
        return !this.percentage ? this.currentValue : ( isNaN(value) ? `-` : `${value} %`)

      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Widgets/increaseDecreaseTooltip.vue